import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { SearchProp } from '../../../../../models';
import { ConnectedFragmentHeader } from './FragmentHeader';
import { HeaderText } from '../parts/HeaderText';
import { HeaderDatesSegments } from '../parts/HeaderDatesSegments';
import { ConnectedHeaderPax } from '../parts/HeaderPax';

export const FragmentHeaderMultiple = ({ currentSearch, textKey }) => {
    const { t } = useTranslation();
    const { segments } = currentSearch;
    const hasDates = !!segments.find((segment) => !!segment.date);

    return (
        <ConnectedFragmentHeader textKey={textKey}>
            <div className="odf-text-center">
                <HeaderText text={t('citySearch.hint.multiple')} />
            </div>
            <div className="odf-text-center">
                <HeaderDatesSegments segments={segments} />
                {hasDates && ' - '}
                <ConnectedHeaderPax />
            </div>
        </ConnectedFragmentHeader>
    );
};

FragmentHeaderMultiple.propTypes = {
    currentSearch: SearchProp.isRequired,
    textKey: PropTypes.string,
};
FragmentHeaderMultiple.defaultProps = {
    textKey: '',
};
